import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ManageAccessAlertMessage, ManageAccessAlertType } from '@mode/shared/ui';
import { AnalyticsEvent } from '@mode/shared/util-segment';

@Component({
  selector: 'mode-external-sharing',
  templateUrl: './external-sharing.component.html',
  styleUrls: ['../share-dialog.component.scss', './external-sharing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExternalSharingComponent {
  @Input() tooltipMessage = '';
  @Input() disabled = false;
  @Input() sharing = false;
  @Output() sharingChange = new EventEmitter<boolean>();
  public readonly tooltipOffset: [number, number] = [0, -25];
  public readonly externalSharingToggleMessage = 'You must be an Editor to modify External Sharing for Reports';
  public toggleOffConfirmationAlert: ManageAccessAlertMessage | null = null;

  public readonly externalSharingToggleOnPayload = {
    location: AnalyticsEvent.SubContext.ShareReport,
    action: AnalyticsEvent.Name.ExternalSharingToggleOn,
  };
  public readonly externalSharingToggleOffPayload = {
    location: AnalyticsEvent.SubContext.ShareReport,
    action: AnalyticsEvent.Name.ExternalSharingToggleOff,
  };

  clearAlert(): void {
    this.toggleOffConfirmationAlert = null;
  }

  confirmTurnOff(): void {
    this.sharingChange.emit(false);
    this.clearAlert();
  }

  onStateChange(turningOn: boolean): void {
    if (turningOn) {
      this.sharingChange.emit(turningOn);
    } else {
      this.toggleOffConfirmationAlert = {
        text: 'Turning off External Sharing will make the Report inaccessible to anyone not signed in to Mode.',
        type: ManageAccessAlertType.Warn,
        confirm: true,
      };
    }
  }
}
